import { Component, OnInit, Input, Output, EventEmitter,  } from '@angular/core';
import { AccountAssessment } from '../../../models/AssessmentModel';
import { AssessmentService } from '../../../services/assessment.service';

@Component({
    selector: 'app-category-risk',
    templateUrl: './category-risk.component.html'
})
export class CategoryRiskComponent implements OnInit {
    _assessment: AccountAssessment;
    _selectedNistFunction: string;
    _selectedNistSubCategory: string;
    selectedNistSubCategory: any;
    nistSubCategories = []

    get assessment(): AccountAssessment { return this._assessment; }

    @Input()
    set assessment(assessment: AccountAssessment) {
        this._assessment = assessment;
        if (this._assessment) {
          this.updateNistSubCategories();
        }
    }

    @Input()
    set selectedNistFunction(selectedNistFunction: string) {
      this._selectedNistFunction = selectedNistFunction;
      this._selectedNistSubCategory = null;
      this.selectedNistSubCategory = null;
      this.updateNistSubCategories();
    }

    @Input()
    set questionDetailSelection(questionDetailSelection: { nistFunction: string, nistSubCategory: string }) {
      if (questionDetailSelection && (this._selectedNistFunction != questionDetailSelection.nistFunction || this._selectedNistSubCategory != questionDetailSelection.nistSubCategory)) {
        this._selectedNistFunction = questionDetailSelection.nistFunction;
        this._selectedNistSubCategory = questionDetailSelection.nistSubCategory;
            this.selectedNistSubCategory = this.nistSubCategories.find(x => this._selectedNistSubCategory === x.id && this._selectedNistFunction === x.scoreData.id.substr(0,2));
         }
    }
    @Output() nistSubCategorySelector: EventEmitter<any> = new EventEmitter();

    private updateNistSubCategories() {
      this.nistSubCategories = this._assessmentService.getNistSubCategoryData(this._assessment, this._selectedNistFunction).sort(
        (a, b) => {
          // return a.scoreData.score - b.scoreData.score;
          const aLE = (a.scoreData.impact / 1000000) * 100 * a.scoreData.exposureFactor;
          const bLE = (a.scoreData.impact / 1000000) * 100 * b.scoreData.exposureFactor;

          return bLE - aLE;
        }
      );
    }

    public setSelectedNistSubCategory(nistSubCategory: any) {
      this._selectedNistSubCategory = nistSubCategory.scoreData.id;
      this._selectedNistFunction = nistSubCategory.scoreData.id.substr(0,2);
      this.selectedNistSubCategory = nistSubCategory;
      this.nistSubCategorySelector.emit({ selectedNistFunction: this._selectedNistFunction, selectedNistSubCategory: this._selectedNistSubCategory });
    }

    constructor(private _assessmentService: AssessmentService) { }

    ngOnInit() { }

    getImportantSubCategories() {
      const highRisk = this.nistSubCategories.filter(el => {
        const rl = this.getRiskLabel(el.scoreData);
        return (rl=='Critical' || rl=='High');
      });

      if (highRisk.length < 5) {
        return this.nistSubCategories.slice(0, 5);
      } else {
        return highRisk;
      }
    }

    getRiskColor(nistSubCategory) {
      return this._assessmentService.getRiskColor(nistSubCategory);
    }

    getRiskLabel(nistSubCategory) {
      return this._assessmentService.getRiskLabel(nistSubCategory);
    }
}
